import { IMsalContext } from "@azure/msal-react";
import { IDeleteRequest } from "./types";
import { getAccessToken } from "config/token";
import { $nexus_api_base_url_v1 } from "../../http";
import { getHeaders, handleRequestError } from "helpers";
import { AxiosError } from "axios";

export const getdeletionrequest = async (
  msalInstance: IMsalContext,
  id: string,
): Promise<{
  data: IDeleteRequest | null | string;
  error: null | string;
}> => {
 try {
    const token = await getAccessToken(msalInstance);

    if (token?.idTokenClaims) {
      const time = parseInt((new Date().getTime() / 1000).toString());

      if (token.idTokenClaims <= time) {
        return {
          data: "Failure to login to application",
          error: "token expired",
        };
      }
    }

    const {
      data,
    }: {
      data: IDeleteRequest;
    } = await $nexus_api_base_url_v1.get( "/nexus/get-hard-delete-request?request_id=" + id, {
      headers: getHeaders(token?.token),
    });

    return {
      error: null,
      data: data,
    };
  } catch (error) {
    return handleRequestError(error as AxiosError | { message: string });
  }
};

export const confirmdeletion = async (
  msalInstance: IMsalContext,
  id: string,
): Promise<{
  data: boolean | null;
  error: null | string;
}> => {
  try {
    const token = await getAccessToken(msalInstance);

    if (token?.idTokenClaims) {
      const time = parseInt((new Date().getTime() / 1000).toString());

      if (token.idTokenClaims <= time) {
        return {
          data: false,
          error: "token expired",
        };
      }
    }

    const {
      data,
    }: {
      data: string;
    } = await $nexus_api_base_url_v1.post("/nexus/update-hard-delete-request-status", JSON.stringify({ "id":id, "confirm":true }), {
      headers: getHeaders(token?.token),
    });

    return {
      error: null,
      data: true,
    };
  } catch (error) {
      return handleRequestError(error as AxiosError | { message: string });
  }
};

export const rejectdeletion = async (
  msalInstance: IMsalContext,
  id: string,
): Promise<{
  data: boolean | null;
  error: null | string;
}> => {
  try {
    const token = await getAccessToken(msalInstance);

    if (token?.idTokenClaims) {
      const time = parseInt((new Date().getTime() / 1000).toString());

      if (token.idTokenClaims <= time) {
        return {
          data: false,
          error: "token expired",
        };
      }
    }

    const {
      data,
    }: {
      data: string;
    } = await $nexus_api_base_url_v1.post("/nexus/update-hard-delete-request-status", JSON.stringify({ "id":id, "confirm":false }), {
      headers: getHeaders(token?.token),
    });

    return {
      error: null,
      data: true,
    };
  } catch (error) {
      return handleRequestError(error as AxiosError | { message: string });
  }
};